require('./brokerHireInvestmentFundStep1.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');

// @ components
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
const BrokerIntervenerList = require('components/broker/brokerIntervener2/brokerIntervenerList/brokerIntervenerList');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { OKLink } = require('commonsComponents/OKLink');
const OKModal = require('components/commons/OKModal/OKModal');
const InformativeItem = require('components/commons/informativeItem/informativeItem');

// @ commons
const { AmountInput } = require('commonsComponents/amountInput');
const { OKMessage } = require('commonsComponents/OKMessage');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const StocksContractDropdown = require('components/broker/commons/stocksContractDropdown/stocksContractDropdown');

// @ helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { toCamelCase } = require('utilities/stringHelper');
const { formatAmountObject, getPlainAmountObject, getFormattedString, formatWithoutRound } = require('utilities/currencyHelper');
const IbanHelper = require('utilities/ibanHelper');
const DateHelper = require('utilities/dateHelper');
const { taggingEventHandled } = require('utilities/taggingEventHandled')
const { PROC_BROKER_FUNDS_PG_NAME } = require('utilities/tagging.js')

// @ constants
const {
    API_ENTERPRISE_NUMBER,
    API_CENTER,
    BROKER_FUNDS_SUBSCRIPTION_CONTRACT_FORMAT,
    BROKER_FUND_NEW_CONTRACT_OPTION,
    BROKER_STOCKS_CONTRACT_DROPDOWN_FUND_SUBSCRIPTION_MODIFIER,
    FIRST_STEP,
    HYPHEN,
    FUNDS_MAX_INPUT_VALUE,
} = require('constants/index');
const { DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');
const { INTERVENER_DESCRIPTIONS } = require('constants/interveners');
const language = getLanguage();

class BrokerHireInvestmentFundStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            initialSubscription: false,
            showModal: true,
        };
        this.handleAccountChange = this.handleAccountChange.bind(this);
        this.buildIntervenerList = this.buildIntervenerList.bind(this);
        this.setAmount = this.setAmount.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleFundContractChange = this.handleFundContractChange.bind(this);
    }

    componentDidMount () {
        const { immInvestmentFunds } = this.props;
        const isin = immInvestmentFunds.getIn(['investmentFunds', 'isin'])
        taggingEventHandled(PROC_BROKER_FUNDS_PG_NAME, 'buyFundStep1', isin)
        this.props.onStepChange('step 1')
    }
    
    setAmount(value) {
        this.props.onSetAmount(value);
    }

    handleCloseModal() {
        this.setState ({
            showModal: false,
        });
    }

    buildModalWarning() {
        const { initialSubscription } = this.state;
        let partialKey = 'modalDescription';
        if (initialSubscription) {
            partialKey = 'initialModalDescription';
        }
        const modalKey = `brokerInternalTransferFundsPreStep-brokerInternalTransferFundsPreStep_${partialKey}`;
        const modalText = formatText(modalKey);
        const modalButtonText = formatText('brokerInternalTransferFundsPreStep-brokerInternalTransferFundsPreStep_modalButtonText');
        return (
            <OKModal
                description={modalText}
                isOpen={this.state.showModal}
                onCloseCallback={this.handleCloseModal}
                onPrimaryButtonClick={this.handleCloseModal}
                footerType="action"
                primaryButtonText={modalButtonText}
                shouldCloseOnOverlayClick={false}
            />
        );
    }

    handleFundContractChange(contractNumber) {
        const {
            immBrokerMyInvestments,
            immAccounts,
            onChangeContract,
            accountSelected,
            immInvestmentFunds,
            setIsSubscription,
            setIsNewContract
        } = this.props;
        const isSubscription = immInvestmentFunds.getIn(['steps', 0, 'isSubscription']);
        if(contractNumber === BROKER_FUND_NEW_CONTRACT_OPTION){
            setIsNewContract();
        } else {
            const accountSelectedContractNumber = immAccounts.getIn([accountSelected, 'contractNumber']);
            const contractSelected = immBrokerMyInvestments.getIn(['products', 'funds', 'stocks'])
                .find((immFund) =>
                    immFund.get('associatedAccountContractNumber') === accountSelectedContractNumber &&
                    immFund.get('contractNumber') === contractNumber
                );
            if(!isSubscription) {
                setIsSubscription(contractSelected.get('id'));
            }
            onChangeContract({
                contractNumber: contractSelected.get('contractNumber'),
                product: contractSelected.get('product'),
                controlDigit: contractSelected.get('controlDigit')
            });
        }
    }

    buildContractInfo(associatedAccountNumber) {
        const { immInvestmentFunds, immBrokerMyInvestments } = this.props
        const isSubscription = immInvestmentFunds.getIn(['steps', 0, 'isSubscription']);
        const selectedContractFund = immInvestmentFunds.getIn(['contractFund', 'contractNumber']);
        const immSelectedProduct = immBrokerMyInvestments.get('contracts').toArray()
            .find((contract) =>
                contract.getIn(['elements', 0, 'contractNumber']) === selectedContractFund
            ).getIn(['elements', 0]);
        if(!selectedContractFund || !immInvestmentFunds || immInvestmentFunds.get('isFetching') || !isSubscription ) {
            return null
        }
        const ownerName = immInvestmentFunds.getIn(['steps', 0, 'intervenersByContract', selectedContractFund])
            && immInvestmentFunds.getIn(['steps', 0, 'intervenersByContract', selectedContractFund, 'nombretitular'])
            ? immInvestmentFunds.getIn(['steps', 0, 'intervenersByContract', selectedContractFund, 'nombretitular'])
            : '-';
        const shares = immSelectedProduct ? formatWithoutRound(immSelectedProduct.get('shares')) : '-';
        const liquidAmount = immInvestmentFunds.get('subscriptionFund') &&
            immInvestmentFunds.getIn(['subscriptionFund', 'liquidAmount'])
            ? immInvestmentFunds.getIn(['subscriptionFund', 'liquidAmount']).toJS()
            : null;
        const liquidAmountFormatted = !!liquidAmount && getFormattedString(liquidAmount, false);
        const formattedLiquidDate = DateHelper.buildFormattedDate(
            immInvestmentFunds.getIn(['subscriptionFund', 'liquidDateToShow']),
            formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)
        );
        const liquidLabel = liquidAmount ? `${liquidAmountFormatted} (${formattedLiquidDate})` : '-'
        return(
            <div className="hire-investment-step1__contract-info-container">
                <div className="hire-investment-step1__separator" />
                <div className="row">
                    <div className="col-xs-3 hire-investment-step1__contract-info-left-col">
                        <InformativeItem
                            title={formatText('brokerHireInvestmentStep1-contractInfo_associatedAccount')}
                            primaryText={associatedAccountNumber}
                        />
                    </div>
                    <div className="col-xs-3 hire-investment-step1__contract-info-mid-left-col">
                        <InformativeItem
                            title={formatText('brokerHireInvestmentStep1-contractInfo_contractOwner')}
                            primaryText={ownerName}
                        />
                    </div>
                    <div className="col-xs-3 hire-investment-step1__contract-info-mid-right-col">
                        <InformativeItem
                            title={formatText('brokerHireInvestmentStep1-contractInfo_shares')}
                            primaryText={shares}
                        />
                    </div>
                    <div className="col-xs-3 hire-investment-step1__contract-info-right-col">
                        <InformativeItem
                            title={formatText('brokerHireInvestmentStep1-contractInfo_lastLiquidValue')}
                            primaryText={liquidLabel}
                        />
                    </div>
                </div>
            </div>
        );
    }

    buildContractDropdown() {
        const {
            immInvestmentFunds,
            immAccounts,
            accountSelected,
            immBrokerMyInvestments,
            setIsNewContract
        } = this.props
        if (immInvestmentFunds.get('isFetching')) {
            return <LoadingSection />
        }
        if(!accountSelected) return null;
        const selectedFundIsin = immInvestmentFunds.getIn(['investmentFunds', 'isin']);
        const immAccountSelected = immAccounts.get(accountSelected)
        const accountSelectedContractNumber = immAccountSelected.get('contractNumber');
        const accountSelectedFullContractNumber = immAccountSelected.get('fullContractNumber');
        const fundsArr = immBrokerMyInvestments.getIn(['products', 'funds', 'stocks'])
            .filter((immFund) =>
                immFund.get('associatedAccountContractNumber') === accountSelectedContractNumber &&
                immFund.get('isin') === selectedFundIsin
            );
        const dropdownOptions = fundsArr.toJS().map((fund) => {
            return {
                totalValue: fund.totalValue,
                totalValueCurrency: fund.totalValueCurrency,
                contractNumber: fund.contractNumber,
                value: fund.contractNumber,
            };
        });
        if(!fundsArr){
            setIsNewContract();
            return null;
        }
        const isSubscription = immInvestmentFunds.getIn(['steps', 0, 'isSubscription']);
        const selectedContractFund = immInvestmentFunds.getIn(['contractFund', 'contractNumber']);
        const contractInfo = dropdownOptions && isSubscription && selectedContractFund
            ? this.buildContractInfo(accountSelectedFullContractNumber)
            : null;
        const interveners = immInvestmentFunds.getIn(['steps', 0, 'originalInterveners']);
        if(interveners.size > 1) {
            const newContractLabel = formatText('brokerHireInvestmentStep1-fundContractDropdown_newContractOption');
            dropdownOptions.push({ value: BROKER_FUND_NEW_CONTRACT_OPTION, totalValue: newContractLabel });
        }
        let dropdownDisabled = false;
        if(dropdownOptions.length === 1) {
            dropdownDisabled = true;
            const uniqueFund = fundsArr.toArray()[0];
            const currentContractSelected = immInvestmentFunds.getIn(['contractFund', 'contractNumber'])
            if(currentContractSelected !== uniqueFund.get('contractNumber')){
                this.handleFundContractChange(uniqueFund.get('contractNumber'));
            }
        }
        const dropdownLabel = 'brokerHireInvestmentStep1-fundContractDropdown_label';
        const dropdownPlaceholder = formatText('brokerHireInvestmentStep1-fundContractDropdown_placeholder');
        return(
            <div className="hire-investment-step1__fund-suscription-selector-section">
                <h3 className="hire-investment-step1__associated-cc-label-subtitle">
                    <FormattedText value="brokerHireInvestmentStep1-fundContractDropdown_title" />
                </h3>
                <StocksContractDropdown
                    placeholder={dropdownPlaceholder}
                    label={dropdownLabel}
                    modifier={BROKER_STOCKS_CONTRACT_DROPDOWN_FUND_SUBSCRIPTION_MODIFIER}
                    options={dropdownOptions}
                    onStockContractChange={this.handleFundContractChange}
                    selectedValue={immInvestmentFunds.getIn(['contractFund','contractNumber'])}
                    disabled={dropdownDisabled}
                />
                {contractInfo}
            </div>
        );
    }


    buildAccountContainer() {
        const {
            immAccounts,
            accountSelected,
            immBrokerMyInvestments,
            immInvestmentFunds,
            immBlockedAccountsIds,
            isBlockedAccountsLoading,
            immFlagBasedFeatures
        } = this.props;

        if (immInvestmentFunds.getIn(['steps', 0, 'fundAccounts'])) {
            const accountAndInterveners = formatText(
                'brokerHireInvestmentStep1-accountsAndInterveners'
            );
            const accountIsValid = immInvestmentFunds.getIn(['steps', 0, 'accountIsValid']);
            const immAccount = immAccounts.get(
                immInvestmentFunds.getIn(['steps', 0, 'accountNumber'])
            );
            let detailsLabel;

            if (immAccount) {
                const accountPrefix = `${API_ENTERPRISE_NUMBER}${API_CENTER}`;
                const contractNumber = immAccount.get('newContractNumber') || '';
                const productNumber = immAccount.get('newProduct') || '';
                const controlDigit = immAccount.getIn(['ibanComplex', 'digitodecontrol'], '');
                const owner = immAccount.get('accountHolder') || '';
                const interventionTypeValue = immAccount.get('interventionType');
                const interventionType = interventionTypeValue
                    ? formatText(`interventionTypes-${interventionTypeValue}`)
                    : '';
                const formattedContractNumber = IbanHelper.formatAccountTextWithSpaces(
                    `${accountPrefix}${controlDigit}${productNumber}${contractNumber}`,
                    BROKER_FUNDS_SUBSCRIPTION_CONTRACT_FORMAT
                );
                const contractLabel = formatText('brokerHireInvestmentStep1-contract');
                const holder = formatText('brokerHireInvestmentStep1-holder');
                const inverventionType = formatText('brokerHireInvestmentStep1-inverventionType');
                detailsLabel = `${contractLabel}${formattedContractNumber} | ${holder}${toCamelCase(
                    owner
                )} | ${inverventionType}${toCamelCase(interventionType)}`;
            }
            const contracNumberSelected = immAccounts.getIn([accountSelected, 'contractNumber']);
            const fundId = immInvestmentFunds.getIn(['investmentFunds', 'customInstitutionSecurityId']);
            const isin = immInvestmentFunds.getIn(['investmentFunds', 'isin']);
            const immFundSelected = immBrokerMyInvestments
                .getIn(['products', 'funds', 'stocks']).filter( fund => fund.get('associatedAccountContractNumber') === contracNumberSelected )
                .find( fundSel => fundSel.get('customInstitutionSecurityId') ===  fundId && fundSel.get('isin') ===  isin)
            const linkedToRobo = !!immFundSelected ? immFundSelected.get('isBlockedByRobo') : false;
            const intervenerList = this.buildIntervenerList(contracNumberSelected);
            const accountsIndexes = this.buildAccountsIndex();
            const featureFlagShowExAnteCostBuyFunds = immFlagBasedFeatures.get('wealth_funds_buy_show_costs');
            const allowZero = __CONTACT_CENTER__ && featureFlagShowExAnteCostBuyFunds
            const accountBalanceInvalid = allowZero
                ? immAccounts.getIn([
                    accountSelected,
                    "balances",
                    "availableBalance",
                    "amount",
                ]) < 0
                : immAccounts.getIn([
                    accountSelected,
                    "balances",
                    "availableBalance",
                    "amount",
                ]) <= 0;
            const errorMessageKey = accountBalanceInvalid ? 'brokerHireInvestmentsStep1-balanceError' : 'brokerHireInvestmentStep1-accountError'
            const errorMessage = formatText(errorMessageKey);
            const tooltipMsg = formatText('brokerHireInvestmentStep1-tooltip1');
            const errorState = (!accountIsValid) || accountBalanceInvalid;
            const modalWarning = linkedToRobo ? this.buildModalWarning(): null;
            const contractDropdown = !!immFundSelected ? this.buildContractDropdown() : null;
            return (
                <div className="hire-investment-step1__account-container">
                    <section className="hire-investment-step1__associated-cc">
                        <label className="hire-investment-step1__associated-cc-label-subtitle">
                            {accountAndInterveners}
                        </label>
                        <div className="hire-investment-step1__associated-cc-stocks-contracts">
                            <DropdownAccounts
                                id="broker-stocks-contracts"
                                immAccounts={immAccounts}
                                accountsIndexes={accountsIndexes}
                                currentAccountId={accountSelected}
                                blockedAccountsIds={immBlockedAccountsIds}
                                onAccountChange={this.handleAccountChange}
                                tooltipMsg={tooltipMsg}
                                label={'brokerHireInvestmentStep1-ccTitle'}
                                error={errorState || linkedToRobo}
                                errorMsg={errorMessage}
                                showAvailableBalance
                                detailsLabel={detailsLabel}
                                loading={isBlockedAccountsLoading}
                            />
                        </div>
                        {modalWarning}
                    </section>
                    {contractDropdown}
                    <section className="hire-investment-step1__interveners">
                        {intervenerList}
                    </section>
                </div>
            );
        } else {
            return <LoadingSection />;
        }
    }

    buildAccountsIndex() {
        const { immAccounts, immInvestmentFunds } = this.props;
        const fundAccounts = immInvestmentFunds.getIn(['steps', 0, 'fundAccounts']);
        const filteredFundAccounts = fundAccounts.filter(id => {
            return immAccounts.has(id);
        });

        const orderedAccounts = filteredFundAccounts.sort((prevId, nextId) => {
            const amountPrev = immAccounts.getIn([prevId, 'balances', 'availableBalance', 'amount']);
            const amountNext = immAccounts.getIn([nextId, 'balances', 'availableBalance', 'amount']);

            return amountPrev > amountNext ? prevId : nextId;
        });

        return orderedAccounts.toList().toJS();
    }

    buildInfoSubs() {
        const { immInvestmentFunds } = this.props;
        const isSubscription = immInvestmentFunds.getIn(['steps', 0, 'isSubscription']);
        if (isSubscription) {
            return (
                <OKMessage type="informative">
                    <FormattedText value="brokerHireInvestmentStep1-info" />
                </OKMessage>
            );
        }
    }

    buildAmountLabelWithAssociatedAccountCurrency() {
        const { immInvestmentFunds, immAccounts } = this.props;
        const accountNumber = immInvestmentFunds.getIn([
            'steps',
            FIRST_STEP,
            'accountNumber'
        ]);
        const immAccount = immAccounts.get(accountNumber);
        const associatedAccountCurrency = immAccount.getIn(['balance', 'currency']);

        return (
            <FormattedText
                value="brokerHireInvestmentStep1-amount2"
                className="hire-investment-step1__associated-cc-amount"
                injectedStrings={[associatedAccountCurrency]}
            />
        );
    }

    buildAmountLabelWithNoCurrency() {
        return (
            <FormattedText
                value="brokerHireInvestmentStep1-amountNoCurrency"
                className="hire-investment-step1__associated-cc-amount"
            />
        );
    }

    buildAmountLabel() {
        const { immInvestmentFunds } = this.props;
        const hasSelectedAssociatedAccount = immInvestmentFunds.getIn([
            'steps',
            FIRST_STEP,
            'accountNumber'
        ]);

        if (hasSelectedAssociatedAccount) {
            return this.buildAmountLabelWithAssociatedAccountCurrency();
        } else {
            return this.buildAmountLabelWithNoCurrency();
        }
    }

    buildInput() {
        const { immInvestmentFunds, immFlagBasedFeatures } = this.props;
        const amount = immInvestmentFunds.getIn(['steps', 0, 'amount']);
        const amountDirty = immInvestmentFunds.getIn(['steps', 0, 'amountDirty']);
        const amountAccountIsValid = immInvestmentFunds.getIn(['steps', 0, 'amountAccountIsValid']);
        const minimumAmountIsValid = immInvestmentFunds.getIn(['steps', 0, 'minimumAmountIsValid']);
        const emptyAmount = immInvestmentFunds.getIn(['steps', 0, 'emptyAmount']);
        const customMinimumPurchaseAmount = immInvestmentFunds.getIn(['steps', 0, 'customMinimumPurchaseAmount']);
        const isSubscription = immInvestmentFunds.getIn(['steps', 0, 'isSubscription']);
        let content;
        if (customMinimumPurchaseAmount) {
            const currency = customMinimumPurchaseAmount.get('currency');
            const minimunAmount = customMinimumPurchaseAmount.get('amount');
            let injectedStrings;
            let minimumMessage;
            let errorState;

            if (emptyAmount) {
                injectedStrings = formatText('brokerHireInvestmentStep1-amountEmptyError');
            } else if (!amountAccountIsValid) {
                injectedStrings = formatText('brokerHireInvestmentStep1-amountError');
            } else if (!minimumAmountIsValid) {
                if (isSubscription) {
                    injectedStrings = formatText('brokerHireInvestmentStep1-minimumAmountErrorSubscription');
                }
                else {
                    injectedStrings = formatText('brokerHireInvestmentStep1-minimumAmountError');
                }
            }
            errorState = emptyAmount || !amountAccountIsValid || !minimumAmountIsValid;

            const plainAmountObject = getPlainAmountObject(customMinimumPurchaseAmount);
            const onlineSymbolObject = currency && minimunAmount ?
                (<OneLineSymbolAmount
                    positiveAmount
                    amountObject={plainAmountObject}
                    language={language}
                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />)
                : HYPHEN;
            const minimumTextMessage = !isSubscription ? "brokerHireInvestmentStep1-minimal" : "brokerHireInvestmentStep1-minimalSuscription";
                minimumMessage = (
                    <div className="hire-investment-step1__associated-cc-minimal">
                        <FormattedText value={minimumTextMessage} />
                        {onlineSymbolObject}
                    </div>
                );
            const featureFlagShowExAnteCostBuyFunds = immFlagBasedFeatures.get('wealth_funds_buy_show_costs');
            const allowZero = __CONTACT_CENTER__ && featureFlagShowExAnteCostBuyFunds;
            content = (
                <div className="hire-investment-step1__input-container">
                    {this.buildAmountLabel()}
                    <div className="hire-investment-step1__tooltip">
                        <OKTooltip
                            content="brokerHireInvestmentStep1-tooltip2"
                            offset={[0, -15]}
                        />
                    </div>
                    <AmountInput
                        amount={amount}
                        callback={this.setAmount}
                        error={errorState && !amountDirty}
                        errorMsg={injectedStrings}
                        hideFocusZero={true}
                        showBlurZero={allowZero}
                        language={language}
                        max={FUNDS_MAX_INPUT_VALUE}
                    />
                    {minimumMessage}
                </div>
            );
        } else {
            content = <div className="hire-investment-step1__input-container" />;
        }

        return content;
    }

    isIntervenerInCurrenSchema(intervener, currentSchema) {
        const name = intervener.get('nomInterviniente').trim();
        const interventionType = intervener.get('tipoIntervencion').trim();
        const isInSchema = currentSchema.filter((currInterv) => (
            name === currInterv.get('name') &&
            interventionType === INTERVENER_DESCRIPTIONS[currInterv.get('interventionType')]
        ), name, interventionType);
        return !isInSchema.isEmpty()
    }

    validInterventionSchema(currentSchema, immAllAcountFundSchemas) {
        const immSchemas = immAllAcountFundSchemas.map(immSchema => {
            return immSchema.getIn(['listadoIntervinientes','intervinientes'])
        }).toArray();
        const isValid = immSchemas.every(immSchema => {
            if(currentSchema.size !== immSchema.size) return true;
            const schemasAreSimilar = immSchema.every(intervener => this.isIntervenerInCurrenSchema(intervener, currentSchema), currentSchema);
            return !schemasAreSimilar
        }, currentSchema);
        return isValid;
    }

    buildIntervenerList(contracNumberSelected) {
        const { immInvestmentFunds, immAccounts, immBrokerMyInvestments } = this.props;
        const isSubscription = immInvestmentFunds.getIn(['steps', 0, 'isSubscription']);
        const immInterveners = immInvestmentFunds.getIn(['steps', 0, 'interveners']);
        const isin = immInvestmentFunds.getIn(['investmentFunds', 'isin']);
        const accountHolder = !!immInvestmentFunds.getIn(['steps', 0, 'userToBlock']) &&
            !!immInvestmentFunds.getIn(['steps', 0, 'userToBlock', 'tipoIntervencion']) &&
            immInvestmentFunds.getIn(['steps', 0, 'userToBlock', 'tipoIntervencion']).trim() === '01' &&
            immInvestmentFunds.getIn(['steps', 0, 'userToBlock', 'nombre']).trim()
        const immFundSelected = immBrokerMyInvestments
                .getIn(['products', 'funds', 'stocks'])
                .filter( immFund =>
                    immFund.get('associatedAccountContractNumber') === contracNumberSelected &&
                    immFund.get('isin') === isin
                );
        const dropdownNoSelection = !immFundSelected.isEmpty() && !immInvestmentFunds.getIn(['contractFund','contractNumber']);
        if(immFundSelected.isEmpty() && immInvestmentFunds.get('isFetching')) {
            return <LoadingSection />;
        }
        if(immInvestmentFunds.get('isFetching') || isSubscription || dropdownNoSelection) {
            return null
        }
        if (!immInterveners.isEmpty()) {
            const immAllAccountFundSchemas = immInvestmentFunds.getIn(['steps', 0, 'intervenersByContract']);
            let validSchema;
            if(immAllAccountFundSchemas){
                validSchema = !immAllAccountFundSchemas.isEmpty() ? this.validInterventionSchema(immInterveners, immAllAccountFundSchemas) : true;
            }else {
                validSchema = true;
            }
            this.props.validateSchema(validSchema);
            return (
                <div>
                    <BrokerIntervenerList
                        immStocksContractForm={immInvestmentFunds}
                        immAccounts={immAccounts}
                        accountHolder={accountHolder}
                        setIntervenerName={this.props.setIntervenerName}
                        setIntervenerType={this.props.setIntervenerType}
                        addIntervener={this.props.addIntervener}
                        removeIntervener={this.props.removeIntervener}
                        restoreDefaultInterveners={this.props.restoreDefaultInterveners}
                        isAdditionalSubscription={isSubscription}
                    />
                    { !validSchema &&
                        <div className="hire-investment-step1__disclaimer-invalid-schema">
                            <OKMessage type="important">
                                <FormattedText value="brokerHireInvestmentStep1-intervenersListDisclaimerContent" />
                            </OKMessage>
                        </div>
                    }
                </div>
            );
        }
    }

    buildDisclaimerInfo() {
        const link = formatText('disclaimerPersonalInfo-buyFundsGdprDisclaimerLinkUrl');

        return (
            <div className="hire-investment-step1__disclaimer-personal-info">
                <OKMessage type="informative">
                    <FormattedText value="disclaimerPersonalInfo-buyFundsGdprDisclaimerText" />
                    &nbsp;
                    <OKLink onClick={() => taggingEventHandled(PROC_BROKER_FUNDS_PG_NAME, 'dataProtectionLinkStep1')} to={link} target="_blank" modifier="emphasize">
                        <FormattedText value="disclaimerPersonalInfo-buyFundsGdprDisclaimerLinkText" />
                    </OKLink>
                </OKMessage>
            </div>
        );
    }

    handleAccountChange(accountId) {
        const { immAccounts, immInvestmentFunds, immBrokerMyInvestments } = this.props;
        const contracNumberSelected = immAccounts.getIn([accountId, 'contractNumber']);
        const fundId = immInvestmentFunds.getIn(['investmentFunds', 'customInstitutionSecurityId']);
        const isin = immInvestmentFunds.getIn(['investmentFunds', 'isin']);
        const immFundSelected = immBrokerMyInvestments
            .getIn(['products', 'funds', 'stocks']).filter( fund => fund.get('associatedAccountContractNumber') === contracNumberSelected )
            .find( fundSel => fundSel.get('customInstitutionSecurityId') ===  fundId && fundSel.get('isin') ===  isin)
        const linkedToRobo = !!immFundSelected ? immFundSelected.get('isBlockedByRobo') : false;
        if (linkedToRobo) {
            this.setState({
                showModal: true,
                initialSubscription: true,
            });
        }
        const accountAmount = immAccounts.getIn([accountId, 'balances', 'availableBalance', 'amount']);
        const isSubscription = immInvestmentFunds.getIn(['steps', 0, 'isSubscription']);
        if(!immFundSelected){
            this.handleFundContractChange(BROKER_FUND_NEW_CONTRACT_OPTION);
            if (isSubscription) {
                this.props.setIsNewContract();
            }
        }
        this.props.onAccountChange(accountId, accountAmount, linkedToRobo);
    }

    render() {
        const title = formatText('brokerHireInvestmentStep1-title');
        const accountsContainer = this.buildAccountContainer();
        const inputContainer = this.buildInput();
        const infoSubs = this.buildInfoSubs();

        return (
            <div className="hire-investment-step1">
                <header className="hire-investment-step1__header">
                    <h2 className="hire-investment-step1__title">
                        {title}
                    </h2>
                </header>
                {accountsContainer}
                {inputContainer}
                {this.buildDisclaimerInfo()}
                {infoSubs}
            </div>
        );
    }
}

BrokerHireInvestmentFundStep1.defaultProps = {
    owner: ''
};

BrokerHireInvestmentFundStep1.propTypes = {
    immAccounts: PropTypes.object,
    immInvestmentFunds: PropTypes.object.isRequired,
    immBlockedAccountsIds: PropTypes.object.isRequired,
    isBlockedAccountsLoading: PropTypes.bool.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    accountSelected: PropTypes.string,
    owner: PropTypes.string,
    onAccountChange: PropTypes.func,
    onSetAmount: PropTypes.func,
    setIntervenerName: PropTypes.func,
    setIntervenerType: PropTypes.func,
    addIntervener: PropTypes.func,
    removeIntervener: PropTypes.func,
    restoreDefaultInterveners: PropTypes.func,
    onChangeContract: PropTypes.func,
    getIntervenersContractByContractNumber: PropTypes.func,
    setIsSubscription: PropTypes.func,
    setIsNewContract: PropTypes.func,
    validateSchema: PropTypes.func,
    immFlagBasedFeatures: PropTypes.object,
    onStepChange: PropTypes.func,
};

module.exports.BrokerHireInvestmentFundStep1 = BrokerHireInvestmentFundStep1;
